import PageContent from "./page-content"

export default PageContent
